// @flow weak

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import Keydown from 'app/common/components/Keydown';
import partiallyApplyComponent from 'app/common/components/partiallyApplyComponent';

const WindowKeydown = partiallyApplyComponent(Keydown, {
  isGlobalEvent: true,
});

export default WindowKeydown;
